// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import { type GetAuthByProviderNameCallbackData, type GetAuthByProviderNameCallbackResponse, type GetAuthByProviderNameLoginData, type PostAuthByProviderNameOneTapData, type PostAuthByProviderNameOneTapResponse, type PostAuthMagicLinkSendData, type PostAuthMagicLinkSendResponse, type PostAuthMagicLinkVerifyData, type PostAuthMagicLinkVerifyResponse, type GetAuthSessionInfoResponse, type PostAuthSessionLogoutResponse, type PostAdminIdentifyData, type PostAdminIdentifyResponse, type GetAdminConnectionsData, type GetAdminConnectionsResponse, type PostAdminAuthRefreshData, type PostAdminAuthRefreshResponse, type PostAuthConfigsData, type PostAuthConfigsResponse, type GetAuthConfigsData, type GetAuthConfigsResponse, type GetAuthConfigsByNanoidData, type GetAuthConfigsByNanoidResponse, type PatchAuthConfigsByNanoidData, type PatchAuthConfigsByNanoidResponse, type DeleteAuthConfigsByNanoidData, type DeleteAuthConfigsByNanoidResponse, type PatchAuthConfigsByNanoidByStatusData, type PatchAuthConfigsByNanoidByStatusResponse, type PostCliCreateSessionResponse, type GetCliGetSessionData, type GetCliGetSessionResponse, type PutCliLinkSessionData, type PutCliLinkSessionResponse, type GetConnectedAccountsData, type GetConnectedAccountsResponse, type PostConnectedAccountsData, type PostConnectedAccountsResponse, type GetConnectedAccountsByNanoidData, type GetConnectedAccountsByNanoidResponse, type DeleteConnectedAccountsByNanoidData, type DeleteConnectedAccountsByNanoidResponse, type PatchConnectedAccountsByNanoIdStatusData, type PatchConnectedAccountsByNanoIdStatusResponse, type PostConnectedAccountsByNanoidRefreshData, type PostConnectedAccountsByNanoidRefreshResponse, type PostInternalTriggerLogsData, type PostInternalTriggerLogsResponse, type PostInternalActionExecutionLogsData, type PostInternalActionExecutionLogsResponse, type GetInternalActionExecutionFieldsResponse, type GetInternalActionExecutionLogByIdData, type GetInternalActionExecutionLogByIdResponse, type GetOpenapiSpecsListResponse, type PostOpenapiSpecsCreateData, type PostOpenapiSpecsCreateResponse, type DeleteOpenapiSpecsByIdData, type DeleteOpenapiSpecsByIdResponse, type GetOpenapiSpecsStatusByIdData, type GetOpenapiSpecsStatusByIdResponse, type GetOrgApiKeyResponse, type PostOrgApiKeyRegenerateResponse, type GetOrgProjectListResponse, type PostOrgProjectNewData, type PostOrgProjectNewResponse, type DeleteOrgProjectDeleteByProjectIdData, type DeleteOrgProjectDeleteByProjectIdResponse, type GetOrgProjectByProjectIdData, type GetOrgProjectByProjectIdResponse, type GetOrgProjectByProjectIdApiKeysListData, type GetOrgProjectByProjectIdApiKeysListResponse, type PostOrgProjectByProjectIdApiKeysCreateData, type PostOrgProjectByProjectIdApiKeysCreateResponse, type PostOrgProjectByProjectIdApiKeysCreateApiKeyData, type PostOrgProjectByProjectIdApiKeysCreateApiKeyResponse, type DeleteOrgProjectByProjectIdApiKeysRemoveByIdData, type DeleteOrgProjectByProjectIdApiKeysRemoveByIdResponse, type GetOrgProjectWebhookData, type GetOrgProjectWebhookResponse, type DeleteOrgProjectWebhookData, type DeleteOrgProjectWebhookResponse, type PostOrgProjectWebhookUpdateData, type PostOrgProjectWebhookUpdateResponse, type PostOrgProjectWebhookRefreshResponse, type GetTeamMembersListResponse, type PostTeamMembersInviteData, type PostTeamMembersInviteResponse, type DeleteTeamMembersRemoveByIdData, type DeleteTeamMembersRemoveByIdResponse, type PutTeamMembersUpdateByIdData, type PutTeamMembersUpdateByIdResponse, type GetToolkitsData, type GetToolkitsResponse, type GetToolkitsCategoriesResponse, type GetToolkitsBySlugData, type GetToolkitsBySlugResponse, type GetToolsData, type GetToolsResponse, type GetToolsEnumResponse, type GetToolsByToolSlugData, type GetToolsByToolSlugResponse, type PostToolsExecuteByActionData, type PostToolsExecuteByActionResponse, type PostToolsExecuteByActionNameInputData, type PostToolsExecuteByActionNameInputResponse, type PostToolsExecuteProxyData, type PostToolsExecuteProxyResponse, type GetTriggerInstancesBySlugByProjectIdHandleData, type GetTriggerInstancesBySlugByProjectIdHandleResponse, type PostTriggerInstancesBySlugByProjectIdHandleData, type PostTriggerInstancesBySlugByProjectIdHandleResponse, type HeadTriggerInstancesBySlugByProjectIdHandleData, type HeadTriggerInstancesBySlugByProjectIdHandleResponse, type PatchTriggerInstancesBySlugStatusByStatusData, type PatchTriggerInstancesBySlugStatusByStatusResponse, type PostTriggerInstancesBySlugUpsertData, type PostTriggerInstancesBySlugUpsertResponse, type DeleteTriggerInstancesBySlugUpsertData, type DeleteTriggerInstancesBySlugUpsertResponse, type GetTriggerInstancesActiveData, type GetTriggerInstancesActiveResponse, type GetTriggersTypesListEnumResponse, type GetTriggersTypesBySlugData, type GetTriggersTypesBySlugResponse, type GetTriggersTypesData, type GetTriggersTypesResponse, type GetOrgProjectTriggerResponse, type PatchOrgProjectTriggerData, type PatchOrgProjectTriggerResponse, type PostPaymentsSessionData, type PostPaymentsSessionResponse, type PostPaymentsManageSubscriptionData, type PostPaymentsManageSubscriptionResponse, type GetAdminCreatePaymentLinkData, type GetAdminCreatePaymentLinkResponse, type PostMcpCommandGenerateData, type PostMcpCommandGenerateResponse, type GetMcpValidateByUuidData, type GetMcpValidateByUuidResponse, type PostMcpCreateData, type PostMcpCreateResponse, type GetMcpByIdData, type GetMcpByIdResponse, type PatchMcpByIdData, type PatchMcpByIdResponse, type DeleteMcpByIdData, type DeleteMcpByIdResponse, type GetMcpAppByAppKeyData, type GetMcpAppByAppKeyResponse, type GetMcpListData, type GetMcpListResponse, type GetFilesListData, type GetFilesListResponse, type PostFilesUploadRequestData, type PostFilesUploadRequestResponse, type PostFilesUploadResponseData, type PostFilesUploadResponseResponse, type GetMigrationGetNanoidData, type GetMigrationGetNanoidResponse, PostOrgProjectNewResponseTransformer, GetOrgProjectByProjectIdResponseTransformer, PostOrgProjectByProjectIdApiKeysCreateResponseTransformer, GetOrgProjectTriggerResponseTransformer, PatchOrgProjectTriggerResponseTransformer } from './types.gen';

/**
 * Handle OAuth provider callback and complete authentication
 * @param data The data for the request.
 * @param data.providerName
 * @param data.code
 * @param data.state
 * @param data.authCode
 * @param data.error
 * @param data.errorDescription
 * @returns unknown Successfully verified OAuth login
 * @returns void Preflight request
 * @throws ApiError
 */
export const getAuthByProviderNameCallback = (data: GetAuthByProviderNameCallbackData): CancelablePromise<GetAuthByProviderNameCallbackResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/auth/{provider_name}/callback',
        path: {
            provider_name: data.providerName
        },
        query: {
            code: data.code,
            state: data.state,
            authCode: data.authCode,
            error: data.error,
            error_description: data.errorDescription
        },
        errors: {
            302: 'Redirect to app with authentication result',
            400: 'Bad request',
            500: 'Internal server error'
        }
    });
};

/**
 * Initiate OAuth login flow with specified provider
 * @param data The data for the request.
 * @param data.providerName
 * @param data.redirectUri
 * @throws ApiError
 */
export const getAuthByProviderNameLogin = (data: GetAuthByProviderNameLoginData): CancelablePromise<void> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/auth/{provider_name}/login',
        path: {
            provider_name: data.providerName
        },
        query: {
            redirectUri: data.redirectUri
        },
        errors: {
            302: 'Redirect to OAuth provider',
            400: 'Bad request',
            500: 'Internal server error'
        }
    });
};

/**
 * Handle one-tap sign-in for supported providers
 * @param data The data for the request.
 * @param data.providerName
 * @param data.requestBody
 * @returns unknown Successfully logged in
 * @throws ApiError
 */
export const postAuthByProviderNameOneTap = (data: PostAuthByProviderNameOneTapData): CancelablePromise<PostAuthByProviderNameOneTapResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/auth/{provider_name}/one-tap',
        path: {
            provider_name: data.providerName
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            302: 'Redirect to app with authentication result',
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Send magic link authentication email to user
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully logged in
 * @throws ApiError
 */
export const postAuthMagicLinkSend = (data: PostAuthMagicLinkSendData = {}): CancelablePromise<PostAuthMagicLinkSendResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/auth/magic_link/send',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad Request',
            500: 'Internal server error'
        }
    });
};

/**
 * Verify magic link token and authenticate user
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully verified magic link
 * @throws ApiError
 */
export const postAuthMagicLinkVerify = (data: PostAuthMagicLinkVerifyData = {}): CancelablePromise<PostAuthMagicLinkVerifyResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/auth/magic_link/verify',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Get current user session information
 * @returns unknown Session is valid
 * @throws ApiError
 */
export const getAuthSessionInfo = (): CancelablePromise<GetAuthSessionInfoResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/auth/session/info',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * End user session and clear authentication
 * @returns unknown Logout successful
 * @throws ApiError
 */
export const postAuthSessionLogout = (): CancelablePromise<PostAuthSessionLogoutResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/auth/session/logout',
        errors: {
            401: 'Unauthorized'
        }
    });
};

/**
 * Identify a user by hash and retrieve client details
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully identified client
 * @throws ApiError
 */
export const postAdminIdentify = (data: PostAdminIdentifyData = {}): CancelablePromise<PostAdminIdentifyResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/admin/identify',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * List connections for a specific toolkit
 * Returns all connections for a given toolkit slug (admin only)
 * @param data The data for the request.
 * @param data.toolkitSlug The toolkit slug to filter connections by
 * @param data.xComposioAdminToken Admin token
 * @returns unknown Successfully retrieved connections
 * @throws ApiError
 */
export const getAdminConnections = (data: GetAdminConnectionsData): CancelablePromise<GetAdminConnectionsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/admin/connections',
        headers: {
            'x-composio-admin-token': data.xComposioAdminToken
        },
        query: {
            toolkit_slug: data.toolkitSlug
        },
        errors: {
            401: 'Unauthorized - Invalid admin token',
            404: 'Toolkit not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Batch refresh access tokens for connected accounts
 * Refreshes tokens for multiple connected accounts in parallel
 * @param data The data for the request.
 * @param data.xComposioAdminToken Admin token
 * @param data.requestBody
 * @returns unknown Successfully refreshed tokens
 * @throws ApiError
 */
export const postAdminAuthRefresh = (data: PostAdminAuthRefreshData): CancelablePromise<PostAdminAuthRefreshResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/admin/auth-refresh',
        headers: {
            'x-composio-admin-token': data.xComposioAdminToken
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized - Invalid admin token',
            500: 'Internal server error'
        }
    });
};

/**
 * Create new authentication configuration
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully created auth config
 * @throws ApiError
 */
export const postAuthConfigs = (data: PostAuthConfigsData = {}): CancelablePromise<PostAuthConfigsResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/auth_configs',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * List authentication configurations with optional filters
 * @param data The data for the request.
 * @param data.isComposioManaged Whether to filter by composio managed auth configs
 * @param data.limit The number of auth configs to return
 * @param data.toolkitSlug The slug of the toolkit to filter by
 * @param data.cursor The cursor to paginate through the auth configs
 * @param data.deprecatedAppId The app id to filter by
 * @param data.deprecatedStatus
 * @returns unknown Successfully fetched auth configs
 * @throws ApiError
 */
export const getAuthConfigs = (data: GetAuthConfigsData = {}): CancelablePromise<GetAuthConfigsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/auth_configs',
        query: {
            is_composio_managed: data.isComposioManaged,
            limit: data.limit,
            toolkit_slug: data.toolkitSlug,
            cursor: data.cursor,
            deprecated_app_id: data.deprecatedAppId,
            deprecated_status: data.deprecatedStatus
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Get single authentication configuration by ID
 * @param data The data for the request.
 * @param data.nanoid
 * @returns unknown Successfully fetched auth config
 * @throws ApiError
 */
export const getAuthConfigsByNanoid = (data: GetAuthConfigsByNanoidData): CancelablePromise<GetAuthConfigsByNanoidResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/auth_configs/{nanoid}',
        path: {
            nanoid: data.nanoid
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Update an authentication configuration
 * @param data The data for the request.
 * @param data.nanoid
 * @param data.requestBody
 * @returns unknown Successfully updated auth config
 * @throws ApiError
 */
export const patchAuthConfigsByNanoid = (data: PatchAuthConfigsByNanoidData): CancelablePromise<PatchAuthConfigsByNanoidResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v3/auth_configs/{nanoid}',
        path: {
            nanoid: data.nanoid
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Delete an authentication configuration
 * @param data The data for the request.
 * @param data.nanoid
 * @returns unknown Successfully deleted auth config
 * @throws ApiError
 */
export const deleteAuthConfigsByNanoid = (data: DeleteAuthConfigsByNanoidData): CancelablePromise<DeleteAuthConfigsByNanoidResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/auth_configs/{nanoid}',
        path: {
            nanoid: data.nanoid
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Auth config not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Enable or disable an authentication configuration
 * @param data The data for the request.
 * @param data.nanoid
 * @param data.status
 * @returns unknown Successfully updated auth config
 * @throws ApiError
 */
export const patchAuthConfigsByNanoidByStatus = (data: PatchAuthConfigsByNanoidByStatusData): CancelablePromise<PatchAuthConfigsByNanoidByStatusResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v3/auth_configs/{nanoid}/{status}',
        path: {
            nanoid: data.nanoid,
            status: data.status
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Create a new CLI session with auth code
 * @returns unknown CLI session created successfully
 * @throws ApiError
 */
export const postCliCreateSession = (): CancelablePromise<PostCliCreateSessionResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/cli/create-session',
        errors: {
            400: 'Bad request',
            500: 'Internal server error'
        }
    });
};

/**
 * Get CLI session details by ID or code
 * @param data The data for the request.
 * @param data.id CLI session ID or code to check
 * @returns unknown CLI session retrieved successfully
 * @throws ApiError
 */
export const getCliGetSession = (data: GetCliGetSessionData): CancelablePromise<GetCliGetSessionResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/cli/get-session',
        query: {
            id: data.id
        },
        errors: {
            400: 'Invalid session ID or code format',
            404: 'CLI session not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Link a CLI session to the authenticated user
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown CLI session linked successfully
 * @throws ApiError
 */
export const putCliLinkSession = (data: PutCliLinkSessionData = {}): CancelablePromise<PutCliLinkSessionResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/v3/cli/link-session',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Invalid session ID or code format, or session already linked',
            401: 'Unauthorized',
            404: 'CLI session or user not found',
            500: 'Internal server error'
        }
    });
};

/**
 * List connected accounts with optional filters
 * @param data The data for the request.
 * @param data.toolkitSlugs The toolkit slugs of the connected accounts
 * @param data.statuses The status of the connected account
 * @param data.cursor The cursor to paginate through the connected accounts
 * @param data.limit The limit of the connected accounts to return
 * @param data.userIds The user ids of the connected accounts
 * @param data.authConfigIds The auth config ids of the connected accounts
 * @param data.orderBy The order by of the connected accounts
 * @param data.labels The labels of the connected accounts
 * @returns unknown Successfully retrieved connected accounts
 * @throws ApiError
 */
export const getConnectedAccounts = (data: GetConnectedAccountsData = {}): CancelablePromise<GetConnectedAccountsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/connected_accounts',
        query: {
            toolkit_slugs: data.toolkitSlugs,
            statuses: data.statuses,
            cursor: data.cursor,
            limit: data.limit,
            user_ids: data.userIds,
            auth_config_ids: data.authConfigIds,
            order_by: data.orderBy,
            labels: data.labels
        },
        errors: {
            400: 'Bad request'
        }
    });
};

/**
 * Create a new connected account
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully created connected account
 * @throws ApiError
 */
export const postConnectedAccounts = (data: PostConnectedAccountsData = {}): CancelablePromise<PostConnectedAccountsResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/connected_accounts',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Get connected account details by ID
 * @param data The data for the request.
 * @param data.nanoid The id of the connected account
 * @returns unknown Successfully retrieved connected account
 * @throws ApiError
 */
export const getConnectedAccountsByNanoid = (data: GetConnectedAccountsByNanoidData): CancelablePromise<GetConnectedAccountsByNanoidResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/connected_accounts/{nanoid}',
        path: {
            nanoid: data.nanoid
        },
        errors: {
            400: 'Bad request',
            500: 'Internal server error'
        }
    });
};

/**
 * Delete a connected account
 * @param data The data for the request.
 * @param data.nanoid The id of the connected account
 * @returns unknown Successfully deleted connected account
 * @throws ApiError
 */
export const deleteConnectedAccountsByNanoid = (data: DeleteConnectedAccountsByNanoidData): CancelablePromise<DeleteConnectedAccountsByNanoidResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/connected_accounts/{nanoid}',
        path: {
            nanoid: data.nanoid
        },
        errors: {
            400: 'Bad request',
            404: 'Connected account not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Enable or disable a connected account
 * @param data The data for the request.
 * @param data.nanoId The id of the connected account
 * @param data.requestBody
 * @returns unknown Successfully updated connected account
 * @throws ApiError
 */
export const patchConnectedAccountsByNanoIdStatus = (data: PatchConnectedAccountsByNanoIdStatusData): CancelablePromise<PatchConnectedAccountsByNanoIdStatusResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v3/connected_accounts/{nanoId}/status',
        path: {
            nanoId: data.nanoId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            404: 'Connected account not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Refresh authentication for a connected account
 * @param data The data for the request.
 * @param data.nanoid The id of the connected account
 * @returns unknown Successfully refreshed connected account
 * @throws ApiError
 */
export const postConnectedAccountsByNanoidRefresh = (data: PostConnectedAccountsByNanoidRefreshData): CancelablePromise<PostConnectedAccountsByNanoidRefreshResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/connected_accounts/{nanoid}/refresh',
        path: {
            nanoid: data.nanoid
        },
        errors: {
            400: 'Bad request',
            500: 'Internal server error'
        }
    });
};

/**
 * Search and retrieve trigger event logs
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully retrieved trigger logs
 * @throws ApiError
 */
export const postInternalTriggerLogs = (data: PostInternalTriggerLogsData = {}): CancelablePromise<PostInternalTriggerLogsResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/internal/trigger/logs',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * Search and retrieve action execution logs
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully retrieved action execution fields
 * @throws ApiError
 */
export const postInternalActionExecutionLogs = (data: PostInternalActionExecutionLogsData = {}): CancelablePromise<PostInternalActionExecutionLogsResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/internal/action_execution/logs',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Get action log fields for filtering
 * @returns unknown Successfully retrieved action execution fields
 * @throws ApiError
 */
export const getInternalActionExecutionFields = (): CancelablePromise<GetInternalActionExecutionFieldsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/internal/action_execution/fields'
    });
};

/**
 * Get detailed execution log by ID
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Successfully retrieved action execution log
 * @throws ApiError
 */
export const getInternalActionExecutionLogById = (data: GetInternalActionExecutionLogByIdData): CancelablePromise<GetInternalActionExecutionLogByIdResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/internal/action_execution/log/{id}',
        path: {
            id: data.id
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * List all OpenAPI specifications
 * @returns unknown Successfully fetched OpenAPI specs
 * @throws ApiError
 */
export const getOpenapiSpecsList = (): CancelablePromise<GetOpenapiSpecsListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/openapi/specs/list',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Create a new OpenAPI specification
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully created OpenAPI spec
 * @throws ApiError
 */
export const postOpenapiSpecsCreate = (data: PostOpenapiSpecsCreateData = {}): CancelablePromise<PostOpenapiSpecsCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/openapi/specs/create',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Delete an OpenAPI specification by ID
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Successfully deleted OpenAPI spec
 * @throws ApiError
 */
export const deleteOpenapiSpecsById = (data: DeleteOpenapiSpecsByIdData): CancelablePromise<DeleteOpenapiSpecsByIdResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/openapi/specs/{id}',
        path: {
            id: data.id
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Get the status of an OpenAPI specification by ID
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Successfully retrieved OpenAPI spec status
 * @throws ApiError
 */
export const getOpenapiSpecsStatusById = (data: GetOpenapiSpecsStatusByIdData): CancelablePromise<GetOpenapiSpecsStatusByIdResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/openapi/specs/status/{id}',
        path: {
            id: data.id
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Get organization API key
 * Retrieve the API key for the current organization (admin only)
 * @returns unknown Successfully retrieved API keys
 * @throws ApiError
 */
export const getOrgApiKey = (): CancelablePromise<GetOrgApiKeyResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/org/api_key',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Regenerate organization API key
 * Generate a new API key for the organization, invalidating the previous one (admin only)
 * @returns unknown API key regenerated successfully
 * @throws ApiError
 */
export const postOrgApiKeyRegenerate = (): CancelablePromise<PostOrgApiKeyRegenerateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/org/api_key/regenerate',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * List all projects
 * Retrieve a list of all projects within the current organization
 * @returns unknown Projects retrieved successfully
 * @throws ApiError
 */
export const getOrgProjectList = (): CancelablePromise<GetOrgProjectListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/org/project/list',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Create a new project
 * Create a new project within the organization with the specified name
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Project Created
 * @throws ApiError
 */
export const postOrgProjectNew = (data: PostOrgProjectNewData = {}): CancelablePromise<PostOrgProjectNewResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/org/project/new',
        body: data.requestBody,
        mediaType: 'application/json',
        responseTransformer: PostOrgProjectNewResponseTransformer,
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.projectId Nano ID of the project
 * @returns unknown Project deleted successfully
 * @throws ApiError
 */
export const deleteOrgProjectDeleteByProjectId = (data: DeleteOrgProjectDeleteByProjectIdData): CancelablePromise<DeleteOrgProjectDeleteByProjectIdResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/org/project/delete/{projectId}',
        path: {
            projectId: data.projectId
        },
        errors: {
            400: 'Project not found',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Get project details by ID
 * Retrieve detailed information about a specific project using its ID
 * @param data The data for the request.
 * @param data.projectId Nano ID of the project
 * @returns unknown Project retrieved successfully
 * @throws ApiError
 */
export const getOrgProjectByProjectId = (data: GetOrgProjectByProjectIdData): CancelablePromise<GetOrgProjectByProjectIdResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/org/project/{projectId}',
        path: {
            projectId: data.projectId
        },
        responseTransformer: GetOrgProjectByProjectIdResponseTransformer,
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.projectId Nano ID of the project
 * @returns unknown Successfully retrieved API keys
 * @throws ApiError
 */
export const getOrgProjectByProjectIdApiKeysList = (data: GetOrgProjectByProjectIdApiKeysListData): CancelablePromise<GetOrgProjectByProjectIdApiKeysListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/org/project/{projectId}/api_keys/list',
        path: {
            projectId: data.projectId
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'API Keys not found',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.projectId Project ID
 * @param data.requestBody
 * @returns unknown API key created successfully
 * @throws ApiError
 */
export const postOrgProjectByProjectIdApiKeysCreate = (data: PostOrgProjectByProjectIdApiKeysCreateData): CancelablePromise<PostOrgProjectByProjectIdApiKeysCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/org/project/{projectId}/api_keys/create',
        path: {
            projectId: data.projectId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        responseTransformer: PostOrgProjectByProjectIdApiKeysCreateResponseTransformer,
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.projectId Project ID
 * @returns unknown Returned existing API key
 * @returns unknown API key created successfully
 * @throws ApiError
 */
export const postOrgProjectByProjectIdApiKeysCreateApiKey = (data: PostOrgProjectByProjectIdApiKeysCreateApiKeyData): CancelablePromise<PostOrgProjectByProjectIdApiKeysCreateApiKeyResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/org/project/{projectId}/api_keys/create-api-key',
        path: {
            projectId: data.projectId
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.id API key ID
 * @param data.projectId Project ID
 * @returns unknown API key deleted successfully
 * @throws ApiError
 */
export const deleteOrgProjectByProjectIdApiKeysRemoveById = (data: DeleteOrgProjectByProjectIdApiKeysRemoveByIdData): CancelablePromise<DeleteOrgProjectByProjectIdApiKeysRemoveByIdResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/org/project/{projectId}/api_keys/remove/{id}',
        path: {
            id: data.id,
            projectId: data.projectId
        },
        errors: {
            400: 'Bad request',
            404: 'API key not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Get webhook URL
 * Get the webhook URL for a project
 * @param data The data for the request.
 * @param data.type Type of the webhook
 * @returns unknown Webhook URL
 * @throws ApiError
 */
export const getOrgProjectWebhook = (data: GetOrgProjectWebhookData): CancelablePromise<GetOrgProjectWebhookResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/org/project/webhook',
        query: {
            type: data.type
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Delete project webhook URL
 * Remove a webhook URL (trigger or event) from the project configuration
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Webhook URL deleted successfully
 * @throws ApiError
 */
export const deleteOrgProjectWebhook = (data: DeleteOrgProjectWebhookData = {}): CancelablePromise<DeleteOrgProjectWebhookResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/org/project/webhook',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Webhook URL updated successfully
 * @throws ApiError
 */
export const postOrgProjectWebhookUpdate = (data: PostOrgProjectWebhookUpdateData = {}): CancelablePromise<PostOrgProjectWebhookUpdateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/org/project/webhook/update',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @returns unknown Webhook URL updated successfully
 * @throws ApiError
 */
export const postOrgProjectWebhookRefresh = (): CancelablePromise<PostOrgProjectWebhookRefreshResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/org/project/webhook/refresh',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * List team members
 * Retrieve a list of all team members in the current organization
 * @returns unknown Successfully retrieved team members
 * @throws ApiError
 */
export const getTeamMembersList = (): CancelablePromise<GetTeamMembersListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/team-members/list',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Invite team member
 * Send an invitation to a new team member to join the organization
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Team member invited successfully
 * @throws ApiError
 */
export const postTeamMembersInvite = (data: PostTeamMembersInviteData = {}): CancelablePromise<PostTeamMembersInviteResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/team-members/invite',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Invalid request',
            401: 'Unauthorized',
            409: 'Member already exists',
            500: 'Internal server error'
        }
    });
};

/**
 * Remove team member
 * Remove a team member from the organization and revoke their access
 * @param data The data for the request.
 * @param data.id
 * @returns unknown Team member removed successfully
 * @throws ApiError
 */
export const deleteTeamMembersRemoveById = (data: DeleteTeamMembersRemoveByIdData): CancelablePromise<DeleteTeamMembersRemoveByIdResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/team-members/remove/{id}',
        path: {
            id: data.id
        },
        errors: {
            400: 'Invalid request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Update team member
 * Update the details of an existing team member
 * @param data The data for the request.
 * @param data.id
 * @param data.requestBody
 * @returns unknown Team member updated successfully
 * @throws ApiError
 */
export const putTeamMembersUpdateById = (data: PutTeamMembersUpdateByIdData): CancelablePromise<PutTeamMembersUpdateByIdResponse> => {
    return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/v3/team-members/update/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Member not found',
            500: 'Internal server error'
        }
    });
};

/**
 * List toolkits
 * Retrieve a list of available toolkits with optional filtering and sorting options
 * @param data The data for the request.
 * @param data.category
 * @param data.managedBy
 * @param data.isLocal
 * @param data.sortBy
 * @returns unknown Successfully retrieved toolkits
 * @throws ApiError
 */
export const getToolkits = (data: GetToolkitsData = {}): CancelablePromise<GetToolkitsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/toolkits',
        query: {
            category: data.category,
            managed_by: data.managedBy,
            is_local: data.isLocal,
            sort_by: data.sortBy
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * List toolkit categories
 * Retrieve a list of all available toolkit categories for filtering toolkits
 * @returns unknown Successfully retrieved categories
 * @throws ApiError
 */
export const getToolkitsCategories = (): CancelablePromise<GetToolkitsCategoriesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/toolkits/categories',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Get toolkit by slug
 * Retrieve detailed information about a specific toolkit using its slug identifier
 * @param data The data for the request.
 * @param data.slug
 * @returns unknown Successfully retrieved toolkit
 * @throws ApiError
 */
export const getToolkitsBySlug = (data: GetToolkitsBySlugData): CancelablePromise<GetToolkitsBySlugResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/toolkits/{slug}',
        path: {
            slug: data.slug
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * List tools
 * Retrieve a list of available tools with optional filtering and search capabilities
 * @param data The data for the request.
 * @param data.toolkitSlug
 * @param data.toolSlugs
 * @param data.cursor
 * @param data.limit
 * @param data.important
 * @param data.tags The tags to filter the tools by
 * @param data.search
 * @returns unknown Successfully retrieved tools
 * @throws ApiError
 */
export const getTools = (data: GetToolsData = {}): CancelablePromise<GetToolsResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/tools',
        query: {
            toolkit_slug: data.toolkitSlug,
            tool_slugs: data.toolSlugs,
            cursor: data.cursor,
            limit: data.limit,
            important: data.important,
            tags: data.tags,
            search: data.search
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Get tool enum list
 * Retrieve a list of all available tool enumeration values (tool slugs) for the project
 * @returns string Successfully retrieved tool enum list
 * @throws ApiError
 */
export const getToolsEnum = (): CancelablePromise<GetToolsEnumResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/tools/enum',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Get tool by slug
 * Retrieve detailed information about a specific tool using its slug identifier
 * @param data The data for the request.
 * @param data.toolSlug
 * @returns unknown Successfully retrieved tool
 * @throws ApiError
 */
export const getToolsByToolSlug = (data: GetToolsByToolSlugData): CancelablePromise<GetToolsByToolSlugResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/tools/{tool_slug}',
        path: {
            tool_slug: data.toolSlug
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Execute tool action
 * Execute a specific tool operation with provided arguments and authentication
 * @param data The data for the request.
 * @param data.action The name of the action
 * @param data.requestBody
 * @returns unknown Successfully executed action
 * @throws ApiError
 */
export const postToolsExecuteByAction = (data: PostToolsExecuteByActionData): CancelablePromise<PostToolsExecuteByActionResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/tools/execute/{action}',
        path: {
            action: data.action
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Not found',
            429: 'Rate limit exceeded',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.actionName The name of the action to get inputs for
 * @param data.requestBody
 * @returns unknown Successfully generated inputs for the action
 * @throws ApiError
 */
export const postToolsExecuteByActionNameInput = (data: PostToolsExecuteByActionNameInputData): CancelablePromise<PostToolsExecuteByActionNameInputResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/tools/execute/{actionName}/input',
        path: {
            actionName: data.actionName
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Failed to generate inputs for the action',
            401: 'Unauthorized',
            500: 'Failed to generate inputs for the action'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully executed proxy request
 * @throws ApiError
 */
export const postToolsExecuteProxy = (data: PostToolsExecuteProxyData = {}): CancelablePromise<PostToolsExecuteProxyResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/tools/execute/proxy',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.slug The slug of the trigger instance
 * @param data.projectId
 * @returns string ok
 * @throws ApiError
 */
export const getTriggerInstancesBySlugByProjectIdHandle = (data: GetTriggerInstancesBySlugByProjectIdHandleData): CancelablePromise<GetTriggerInstancesBySlugByProjectIdHandleResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/trigger_instances/{slug}/{projectId}/handle',
        path: {
            slug: data.slug,
            projectId: data.projectId
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.slug The slug of the trigger instance
 * @param data.projectId
 * @returns string ok
 * @throws ApiError
 */
export const postTriggerInstancesBySlugByProjectIdHandle = (data: PostTriggerInstancesBySlugByProjectIdHandleData): CancelablePromise<PostTriggerInstancesBySlugByProjectIdHandleResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/trigger_instances/{slug}/{projectId}/handle',
        path: {
            slug: data.slug,
            projectId: data.projectId
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.slug The slug of the trigger instance
 * @param data.projectId
 * @returns string ok
 * @throws ApiError
 */
export const headTriggerInstancesBySlugByProjectIdHandle = (data: HeadTriggerInstancesBySlugByProjectIdHandleData): CancelablePromise<HeadTriggerInstancesBySlugByProjectIdHandleResponse> => {
    return __request(OpenAPI, {
        method: 'HEAD',
        url: '/api/v3/trigger_instances/{slug}/{projectId}/handle',
        path: {
            slug: data.slug,
            projectId: data.projectId
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.slug The slug of the trigger instance
 * @param data.status The new status of the trigger
 * @returns unknown Successfully updated trigger status
 * @throws ApiError
 */
export const patchTriggerInstancesBySlugStatusByStatus = (data: PatchTriggerInstancesBySlugStatusByStatusData): CancelablePromise<PatchTriggerInstancesBySlugStatusByStatusResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v3/trigger_instances/{slug}/status/{status}',
        path: {
            slug: data.slug,
            status: data.status
        },
        errors: {
            400: 'Bad Request',
            401: 'Unauthorized',
            404: 'Trigger instance not found',
            500: 'Internal Server Error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.slug The slug of the trigger instance
 * @param data.requestBody
 * @returns unknown Successfully updated trigger instance
 * @returns EmptyResponse No content
 * @throws ApiError
 */
export const postTriggerInstancesBySlugUpsert = (data: PostTriggerInstancesBySlugUpsertData): CancelablePromise<PostTriggerInstancesBySlugUpsertResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/trigger_instances/{slug}/upsert',
        path: {
            slug: data.slug
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Trigger instance not found',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.slug The slug of the trigger instance
 * @returns unknown Successfully updated trigger instance
 * @throws ApiError
 */
export const deleteTriggerInstancesBySlugUpsert = (data: DeleteTriggerInstancesBySlugUpsertData): CancelablePromise<DeleteTriggerInstancesBySlugUpsertResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/trigger_instances/{slug}/upsert',
        path: {
            slug: data.slug
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'Trigger instance not found',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.connectedAccountIds Array of connected account IDs to filter triggers by
 * @param data.authConfigIds Array of auth config IDs to filter triggers by
 * @param data.triggerIds Array of trigger IDs to filter triggers by
 * @param data.triggerNames Array of trigger names to filter triggers by
 * @param data.page Page number for pagination. Starts from 1.
 * @param data.limit Number of items to return per page.
 * @param data.showDisabled When set to true, includes disabled triggers in the response.
 * @param data.deprecatedConnectedAccountUuids Array of connected account UUIDs to filter triggers by
 * @param data.deprecatedAuthConfigUuids Array of auth config UUIDs to filter triggers by
 * @returns unknown Successfully retrieved active trigger instances
 * @throws ApiError
 */
export const getTriggerInstancesActive = (data: GetTriggerInstancesActiveData = {}): CancelablePromise<GetTriggerInstancesActiveResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/trigger_instances/active',
        query: {
            connectedAccountIds: data.connectedAccountIds,
            authConfigIds: data.authConfigIds,
            triggerIds: data.triggerIds,
            triggerNames: data.triggerNames,
            page: data.page,
            limit: data.limit,
            showDisabled: data.showDisabled,
            deprecatedConnectedAccountUuids: data.deprecatedConnectedAccountUuids,
            deprecatedAuthConfigUuids: data.deprecatedAuthConfigUuids
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @returns string Successfully retrieved trigger enum list
 * @throws ApiError
 */
export const getTriggersTypesListEnum = (): CancelablePromise<GetTriggersTypesListEnumResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/triggers_types/list/enum',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Get trigger type by slug
 * Retrieve detailed information about a specific trigger type using its slug identifier
 * @param data The data for the request.
 * @param data.slug
 * @returns unknown Successfully retrieved trigger type
 * @throws ApiError
 */
export const getTriggersTypesBySlug = (data: GetTriggersTypesBySlugData): CancelablePromise<GetTriggersTypesBySlugResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/triggers_types/{slug}',
        path: {
            slug: data.slug
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * List trigger types
 * Retrieve a list of available trigger types with optional filtering by toolkit
 * @param data The data for the request.
 * @param data.cursor
 * @param data.limit
 * @param data.toolkitSlugs Array of toolkit slugs
 * @returns unknown Successfully retrieved triggers
 * @throws ApiError
 */
export const getTriggersTypes = (data: GetTriggersTypesData = {}): CancelablePromise<GetTriggersTypesResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/triggers_types',
        query: {
            cursor: data.cursor,
            limit: data.limit,
            toolkit_slugs: data.toolkitSlugs
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @returns unknown Project retrieved successfully
 * @throws ApiError
 */
export const getOrgProjectTrigger = (): CancelablePromise<GetOrgProjectTriggerResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/org/project/trigger',
        responseTransformer: GetOrgProjectTriggerResponseTransformer,
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.enabled Enabled
 * @returns unknown Project retrieved successfully
 * @throws ApiError
 */
export const patchOrgProjectTrigger = (data: PatchOrgProjectTriggerData): CancelablePromise<PatchOrgProjectTriggerResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v3/org/project/trigger',
        query: {
            enabled: data.enabled
        },
        responseTransformer: PatchOrgProjectTriggerResponseTransformer,
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Payment link created successfully
 * @throws ApiError
 */
export const postPaymentsSession = (data: PostPaymentsSessionData = {}): CancelablePromise<PostPaymentsSessionResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/payments/session',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Billing portal session created successfully
 * @throws ApiError
 */
export const postPaymentsManageSubscription = (data: PostPaymentsManageSubscriptionData = {}): CancelablePromise<PostPaymentsManageSubscriptionResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/payments/manage-subscription',
        body: data.requestBody,
        mediaType: 'application/json'
    });
};

/**
 * @param data The data for the request.
 * @param data.amount Payment amount in cents
 * @param data.email Customer email address
 * @param data.description Description of the payment
 * @returns unknown Payment link created successfully
 * @throws ApiError
 */
export const getAdminCreatePaymentLink = (data: GetAdminCreatePaymentLinkData): CancelablePromise<GetAdminCreatePaymentLinkResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/admin/create-payment-link',
        query: {
            amount: data.amount,
            email: data.email,
            description: data.description
        },
        errors: {
            302: 'Redirect to payment page'
        }
    });
};

/**
 * Generate CLI command to set up MCP server
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully generated MCP server command
 * @throws ApiError
 */
export const postMcpCommandGenerate = (data: PostMcpCommandGenerateData = {}): CancelablePromise<PostMcpCommandGenerateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/mcp/command/generate',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'MCP server not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Validate MCP server and retrieve connection details
 * @param data The data for the request.
 * @param data.uuid UUID of the MCP server to validate
 * @param data.xComposioAdminToken Admin token
 * @returns unknown Successfully validated MCP server
 * @throws ApiError
 */
export const getMcpValidateByUuid = (data: GetMcpValidateByUuidData): CancelablePromise<GetMcpValidateByUuidResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/mcp/validate/{uuid}',
        path: {
            uuid: data.uuid
        },
        headers: {
            'x-composio-admin-token': data.xComposioAdminToken
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized - Invalid admin token',
            404: 'MCP server not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Create a new MCP server
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully created MCP server
 * @throws ApiError
 */
export const postMcpCreate = (data: PostMcpCreateData = {}): CancelablePromise<PostMcpCreateResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/mcp/create',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Get MCP server details by ID
 * @param data The data for the request.
 * @param data.id The ID of the MCP server
 * @returns unknown Successfully retrieved MCP server
 * @throws ApiError
 */
export const getMcpById = (data: GetMcpByIdData): CancelablePromise<GetMcpByIdResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/mcp/{id}',
        path: {
            id: data.id
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'MCP server not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Update MCP server configuration
 * @param data The data for the request.
 * @param data.id The ID of the MCP server
 * @param data.requestBody
 * @returns unknown Successfully updated MCP server
 * @throws ApiError
 */
export const patchMcpById = (data: PatchMcpByIdData): CancelablePromise<PatchMcpByIdResponse> => {
    return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/v3/mcp/{id}',
        path: {
            id: data.id
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'MCP server not found',
            500: 'Internal server error'
        }
    });
};

/**
 * Delete an MCP server
 * @param data The data for the request.
 * @param data.id The ID of the MCP server
 * @returns unknown Successfully deleted MCP server
 * @throws ApiError
 */
export const deleteMcpById = (data: DeleteMcpByIdData): CancelablePromise<DeleteMcpByIdResponse> => {
    return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/v3/mcp/{id}',
        path: {
            id: data.id
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'MCP server not found',
            500: 'Internal server error'
        }
    });
};

/**
 * List MCP servers for a specific app
 * @param data The data for the request.
 * @param data.appKey The key of the app to find MCP servers for
 * @returns unknown Successfully retrieved MCP servers for app
 * @throws ApiError
 */
export const getMcpAppByAppKey = (data: GetMcpAppByAppKeyData): CancelablePromise<GetMcpAppByAppKeyResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/mcp/app/{appKey}',
        path: {
            appKey: data.appKey
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            404: 'App not found',
            500: 'Internal server error'
        }
    });
};

/**
 * List MCP servers with optional filters
 * @param data The data for the request.
 * @param data.connectedAccountId Connected account IDs to filter by
 * @param data.integrationId Integration ID to filter by
 * @param data.appId App IDs to filter by
 * @param data.entityId Entity IDs to filter by
 * @param data.cursor Cursor for pagination
 * @param data.limit Limit for pagination
 * @returns unknown Successfully retrieved MCP servers
 * @throws ApiError
 */
export const getMcpList = (data: GetMcpListData = {}): CancelablePromise<GetMcpListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/mcp/list',
        query: {
            connected_account_id: data.connectedAccountId,
            integration_id: data.integrationId,
            app_id: data.appId,
            entity_id: data.entityId,
            cursor: data.cursor,
            limit: data.limit
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * List files with optional app and action filters
 * @param data The data for the request.
 * @param data.toolkitSlug Slug of the app where this file belongs to.
 * @param data.toolSlug Name of the action where this file belongs to.
 * @returns unknown Successfully retrieved files
 * @throws ApiError
 */
export const getFilesList = (data: GetFilesListData = {}): CancelablePromise<GetFilesListResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/files/list',
        query: {
            toolkit_slug: data.toolkitSlug,
            tool_slug: data.toolSlug
        },
        errors: {
            400: 'Bad request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};

/**
 * Create presigned URL for request file upload to S3
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successfully created upload URL for request file
 * @throws ApiError
 */
export const postFilesUploadRequest = (data: PostFilesUploadRequestData = {}): CancelablePromise<PostFilesUploadRequestResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/files/upload/request',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad Request',
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Not Found',
            410: 'Gone',
            429: 'Too Many Requests',
            500: 'Internal Server Error',
            501: 'Not Implemented'
        }
    });
};

/**
 * Create presigned URL for response file upload to S3 (admin only)
 * @param data The data for the request.
 * @param data.adminToken Required admin token for authorization to upload response files
 * @param data.requestBody
 * @returns unknown Successfully created upload URL for response file
 * @throws ApiError
 */
export const postFilesUploadResponse = (data: PostFilesUploadResponseData): CancelablePromise<PostFilesUploadResponseResponse> => {
    return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v3/files/upload/response',
        query: {
            adminToken: data.adminToken
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'Bad Request',
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Not Found',
            410: 'Gone',
            429: 'Too Many Requests',
            500: 'Internal Server Error',
            501: 'Not Implemented'
        }
    });
};

/**
 * Get NanoId from UUID
 * Convert a legacy UUID to its corresponding NanoId for migration purposes
 * @param data The data for the request.
 * @param data.uuid
 * @param data.type
 * @param data.xApiKey
 * @returns unknown Successfully retrieved NanoId
 * @throws ApiError
 */
export const getMigrationGetNanoid = (data: GetMigrationGetNanoidData): CancelablePromise<GetMigrationGetNanoidResponse> => {
    return __request(OpenAPI, {
        method: 'GET',
        url: '/api/v3/migration/get-nanoid',
        headers: {
            'x-api-key': data.xApiKey
        },
        query: {
            uuid: data.uuid,
            type: data.type
        },
        errors: {
            400: 'Bad Request',
            401: 'Unauthorized',
            500: 'Internal server error'
        }
    });
};